import { AppSettingsService } from "../../services/appsettings.service";
import { AuthenticationService } from "../../services/authentication.service";
import { TiersService } from "../../services/tiers.service";
import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

interface Langue {
  text: string;
  value: string;
}

@Component({
  selector: "app-login",
  styleUrls: ["./login.component.scss"],
  templateUrl: "./login.component.html"
})
export class cls_login {
  /* ###########################################  VARIABLES  #######################################################*/

  /** Nom de la page afin de gérer la traduction */
  public w_titre_trad = "loginPage.";
  /** Session en cours */
  public h_currentUser: any;
  /** Flag de chargement */
  public f_loading: boolean = false;

  /** Clé MD5 pour rattachement à un CDG */
  public w_tiersIdMD5: string = null;
  /** Donnée du Chef de grappe */
  public h_cdg: any;

  /** Formulaire de saisie du login */
  public form_login: FormGroup;

  /** Listes des langues pour choix de traduction */
  public h_listLangues: Array<Langue> = [
    { text: "Deutsch", value: "de" },
    { text: "Österreicher", value: "de-AT" },
    { text: "English", value: "en" },
    { text: "Francais", value: "fr" },
    { text: "Magyar", value: "hu" },
    { text: "Italiano", value: "it" },
    { text: "Português", value: "pt" }
  ];

  /** Langue sélectionnée */
  public h_selectedLangue: Langue;

  /* ###########################################  CONSTRUCTEUR  ####################################################*/

  /**
   * Constructeur
   */
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public s_authentication: AuthenticationService,
    public s_translate: TranslateService,
    public s_tiers: TiersService,
    public s_appsettings: AppSettingsService,
    public fb: FormBuilder
  ) {
    this.f_loading = true;

    // Par défaut on choisit la langue du navigateur
    this.s_appsettings.proc_initLangue();
    this.h_selectedLangue = { text: "", value: this.s_translate.currentLang };

    //Initialisation du formulaire de login
    this.form_login = this.fb.group({
      username: [, [Validators.required]],
      password: [, [Validators.required]]
    });

    //Recuperation du parametre se trouvant dans le lien pour ajouter un CDG, si jamais il existe
    this.route.params.subscribe(params => {
      if (params["tiersId"]) this.w_tiersIdMD5 = params["tiersId"];

      //S'il existe on recupere le CDG de l'utilisateur
      if (this.w_tiersIdMD5 != null) {
        //Timeout pour laisser le temps au service d'aller chercher le pathAPI
        setTimeout(() => {
          this.s_tiers.proc_getTiersbyMd5id(this.w_tiersIdMD5).subscribe(
            data => {
              this.h_cdg = data;
              if (this.h_cdg == null) this.w_tiersIdMD5 = null;

              this.f_loading = false;
            },
            error => {
              this.s_appsettings.proc_gestionErreur(error);
              this.router.navigate(["auth/login"]);
              this.f_loading = false;
            }
          );
        });
      } else this.f_loading = false;
    });
  }

  /* ###########################################  FONCTIONS  #######################################################*/

  /**
   * Changement de langue
   */
  public proc_onChangeLangue(h_val: any) {
    this.s_translate.use(h_val.value);
  }

  /**
   * Authentification de l'utilisateur
   */
  public proc_login() {
    this.f_loading = true;

    //Si l'utilisateur est connecté, on détruit sa session locale avant d'en créer une nouvelle
    this.s_authentication.proc_logout();
    this.s_authentication
      .proc_login(
        this.form_login.value.username,
        this.form_login.value.password,
        this.w_tiersIdMD5
      )
      .subscribe(
        data => {
          //On recupere l'user pour savoir s'il a ou non des CGV a valider
          this.h_currentUser = JSON.parse(localStorage.getItem("currentUser"));

          if (this.h_currentUser.CGVValid === "false")
            this.router.navigate(["pages/commun/pageCGV"]);
          else this.router.navigate(["pages/commun/pageAccueil"]);
        },
        error => {
          this.s_appsettings.proc_gestionErreur(error);
          this.f_loading = false;
        }
      );
  }

  /**
   * Inscription de l'utilisateur
   */
  public proc_goToRegister() {
    if (this.w_tiersIdMD5 != null)
      this.router.navigate(["auth/register/" + this.w_tiersIdMD5]);
    else this.router.navigate(["auth/register"]);
  }

  /**
   * Récupèration du mot de passe
   */
  public proc_goToRecupMdp() {
    this.router.navigate(["auth/recupMDP"]);
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/pages/login/login.component.ts